<template>
  <li class="menu-builder__item-wrap" :data-id="content.id">
    <div v-if="isReady" class="menu-builder__item">
      <div class="menu-builder__item-inner">
        <div class="menu-builder__item-img">
          <img :src="entity.image ? entity.image.public_url : ''" alt="">
        </div>
        <div class="menu-builder__item-data">
          <div class="menu-builder__item-data-row _id">
            <b>ID:</b> <span>{{ entity.id }}</span>
          </div>
          <div class="menu-builder__item-data-row _title">
            <b>Title:</b> <span>{{ entity.title }}</span>
          </div>
          <div class="menu-builder__item-data-row _url">
            <b>Url:</b> <span>{{ entity.url }}</span>
          </div>
        </div>
        <div class="menu-builder__item-btns">
          <i v-if="entity.hidden" class="fa fa-2x fa-eye-slash disabled" aria-hidden="true" />
          <button class="btn btn-primary btn-add">Add item</button>
          <button class="btn btn-primary btn-edit">Edit</button>
          <button class="btn btn-warning btn-open">Open</button>
          <button class="btn btn-danger btn-delete">Delete</button>
        </div>
      </div>
    </div>
    <ul v-if="entity.children && entity.children.length">
      <menu-item
        v-for="item in content.children"
        :key="item.id"
        :content="item"
      />
    </ul>
  </li>
</template>

<script>
import _ from 'lodash';

export default {
  name: 'MenuItem',

  props: {
    content: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      isReady: false,
      entity: {},
    };
  },

  watch: {
    content(val) {
      this.copyContent(val);
    },
  },

  mounted() {
    this.copyContent(this.content);
    this.isReady = true;
  },

  methods: {
    copyContent(content) {
      this.entity.id = content.id;
      this.entity.menu_id = content.menu_id;
      this.entity.parent_id = content.parent_id;
      this.entity.order = content.order;
      this.entity.title = content.title;
      this.entity.tooltip = content.tooltip;
      this.entity.target = content.target;
      this.entity.url = content.url;
      this.entity.image = content.image;
      this.entity.hidden = content.hidden;
      this.entity.children = _.sortBy(content.children, item => item.order);
    },
  },
};
</script>

<style scoped>
  .fa.disabled {
    margin-right: 40px;
  }
  .fa.disabled::before {
    padding-top: 3px;
  }
  .disabled-item {
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }
</style>



// WEBPACK FOOTER //
// MenuItem.vue?522c7664